var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"document-container"},[_c('div',{staticClass:"columns is-desktop"},[_c('div',{staticClass:"column"},[_c('retire-merge-id')],1),_c('div',{staticClass:"column is-3"},[_c('quick-tips-retire-merge-id')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }